import { create } from 'zustand'

const useSeccionesStore = create((set,get) => ({
    isLoading: true,
    secciones: [],
    iniciar: async() => {
      if (localStorage.getItem('isLoggedIn') === 'true') {
          fetch("/p_secciones")
          .then((res) => res.json())
          .then(async(data) => {
            // console.log('Las secciones',data);
            if (data['status'] === 1 && Array.isArray(data['data'])) {
              set({secciones: data['data']});
            }
          });
      }
    }
}))
  
export default useSeccionesStore